import CharScene from '../char-scenes/char-scene.entity';
import EpisodicProp from '../episodic-props/episodic-prop.entity';
import PrWrapBoxEpisodicProp from '../pr-wrap-box-episodic-props/pr-wrap-box-episodic-prop.entity';
import PropSceneCharScene from '../prop-scene-char-scenes/prop-scene-char-scene.entity';
import {
	SosCreateResponse,
	SosDeleteResponse,
	SosListResponse,
} from '../sos-response';
import PropScene from './prop-scene.entity';

export interface PropSceneCreateResponse extends SosCreateResponse {
	created: {
		PropScene: PropScene[];
		PropSceneCharScene?: PropSceneCharScene[];
	};
}

export interface PropSceneListResponse extends SosListResponse {
	listed: {
		PropScene: PropScene[];
		PropSceneCharScene?: PropSceneCharScene[];
	};
}

export interface PropSceneCreateWithEpisodicPropResponse
	extends SosCreateResponse {
	created: {
		EpisodicProp: EpisodicProp[];
		PropScene: PropScene[];
		PrWrapBoxEpisodicProp: PrWrapBoxEpisodicProp[];
	};
}

export interface PropSceneByEpCharListResponse extends SosListResponse {
	listed: {
		CharScene: CharScene[];
		EpisodicProp: EpisodicProp[];
		PropSceneCharScene: PropSceneCharScene[];
		PropScene: PropScene[];
	};
}

export interface PropSceneDeleteResponse extends SosDeleteResponse {
	destroyed: {
		PropScene: PropScene[];
		PropSceneCharScene: PropSceneCharScene[];
	};
}
